"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _clientStorage = require("../clientStorage");
var _getAuthStateKeys = _interopRequireDefault(require("./getAuthStateKeys"));

/**
 * check for existence of an auth state key
 */
var isAuthStateSet = function isAuthStateSet(clientStorageType) {
  switch (clientStorageType) {
    case _clientStorage.CLIENT_STORAGE_COOKIES:
      return !!(0, _getAuthStateKeys.default)(_clientStorage.CLIENT_STORAGE_COOKIES).length;
    case _clientStorage.CLIENT_STORAGE_LOCAL_STORAGE:
      return !!(0, _getAuthStateKeys.default)(_clientStorage.CLIENT_STORAGE_LOCAL_STORAGE).length;
    case _clientStorage.CLIENT_STORAGE_ALL:
    default:
      return !!(0, _getAuthStateKeys.default)(_clientStorage.CLIENT_STORAGE_ALL).length;
  }
};
var _default = isAuthStateSet;
exports.default = _default;